import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import WaitingListsData from '@/ts/WaitingListsData';
import { WaitingListDataResponse, ApplicationDataResponse } from '@/ts/HococoInterfaces';
import { NotifyHelpers } from '@/ts/helpers/NotifyHelpers';

@Module({name: 'WaitingLists', namespaced: true})
export default class WaitingLists extends VuexModule {
    public waitingLists: WaitingListsData[] = [];
    public availableApartments: any = [];
    public previewApplicationVisible: boolean = false;
    public availableApartmentsVisible: boolean = false;
    public expirationEmailVisible: boolean = false;
    public previewedApplication: any = [];
    public applicationMasterData: any = null;
    public previewedDocument: any = '';
    public previewedDocumentLoading: any = false;
    public previewedDocumentOriginalName: string = '';
    public previewedDocumentExtention: string = '';
    public previewedApplicationState: string = '';
    public oauthClientData: any = null;
    public selectedApartmentId: number = 0;

    @Mutation
    public RESET_WAITING_LIST_STORE_STATE() {
        this.waitingLists                  = [];
        this.availableApartments           = [];
        this.previewApplicationVisible     = false;
        this.availableApartmentsVisible    = false;
        this.expirationEmailVisible        = false;
        this.previewedApplication          = [];
        this.applicationMasterData         = null;
        this.previewedDocument             = '';
        this.previewedDocumentLoading      = false;
        this.previewedDocumentOriginalName = '';
        this.previewedDocumentExtention    = '';
        this.previewedApplicationState     = '';
        this.oauthClientData               = null;
        this.selectedApartmentId           = 0;
    }

    get getAllWaitingLists(): WaitingListsData[] {
        return this.waitingLists;
    }

    get getAvailableApartments() {
        return this.availableApartments;
    }

    get getSelectedApartmentId() {
        return this.selectedApartmentId;
    }

    get getIfreviewApplicationVisible() {
        return this.previewApplicationVisible;
    }

    get getAvailableApartmentsVisible() {
        return this.availableApartmentsVisible;
    }

    get getExpirationEmailVisible() {
        return this.expirationEmailVisible;
    }

    get getPreviewedApplication() {
        return this.previewedApplication;
    }

    get getPreviewedApplicationState() {
        return this.previewedApplicationState;
    }

    get getPreviewedDocument() {
        return this.previewedDocument;
    }

    get getPreviewedDocumentOriginalName() {
        return this.previewedDocumentOriginalName;
    }

    get getPreviewedDocumentExtention() {
        return this.previewedDocumentExtention;
    }

    get getPreviewedDocumentLoading() {
        return this.previewedDocumentLoading;
    }

    get getOauthClientData() {
        return this.oauthClientData;
    }

    get getApplicationMasterData(): any {
        return this.applicationMasterData;
    }

    @Action
    public FETCH_ALL_WAITING_LISTS() {
        store.commit(Mutations.RESET_WAITING_LISTS);

        axios.get(Endpoints.Admin.WaitingList.WAITING_LISTS, { params: {type: 'all'} })
            .then((response: any) => {
                store.commit(Mutations.SET_ALL_WAITING_LISTS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public TOGGLE_WAITING_LIST_TAB(requestOption: string) {
        store.commit(Mutations.RESET_WAITING_LISTS);

        return axios.get(Endpoints.Admin.WaitingList.WAITING_LISTS, { params: {type: requestOption} })
            .then((response: any) => {
                store.commit(Mutations.SET_ALL_WAITING_LISTS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_CURRENT_PREVIEWED_APPLICATION(applicationId: number) {
        axios.get(Endpoints.Admin.WaitingList.CURRENT_APPLICATION(applicationId))
            .then((response: any) => {
                store.commit(Mutations.SET_CURRENT_PREVIEWED_APPLICATION, response.data);
                store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, true);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_CURRENT_APPLICATION_MASTER_DATA(applicationId: number) {
        axios.get(Endpoints.Admin.WaitingList.APPLICATION_MASTER_DATA(applicationId))
            .then((response: any) => {
                store.commit(Mutations.SET_APPLICATION_MASTER_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public RESET_ACTIVE_APPLICATION_ROWS() {
        const rows = document.querySelectorAll('.applicationItem');
        rows.forEach( (row) => row.classList.remove('active'));
    }

    @Action
    public RESET_PREVIEW_ALL_ACTIONS() {
        store.commit(Mutations.SET_SELECTED_APARTMENT_ID, 0);
        const rowss = document.querySelectorAll('.typeBlockItem');
        rowss.forEach( (row) => row.classList.remove('activeTypeBlockItem'));
        const rows = document.querySelectorAll('.applicationItem');
        rows.forEach( (row) => row.classList.remove('active'));
        store.commit(Mutations.SET_AVAILABLE_APARTMENTS_VISIBILITY, false);
        store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, false);
    }

    @Action
    public RESET_ACTIVE_APARTMENT_ROWS(selectedRowId: any) {
        store.commit(Mutations.SET_SELECTED_APARTMENT_ID, selectedRowId);
        const rows = document.querySelectorAll('.typeBlockItem');
        rows.forEach( (row) => row.classList.remove('activeTypeBlockItem'));
    }

    @Action
    public FETCH_PREVIEWED_DOCUMENT(documentId: number) {
        store.commit(Mutations.SET_PREVIEWED_DOCUMENT_LOADING);

        axios.get(Endpoints.Admin.PresentationFlow.PREVIEW_DOCUMENT(documentId))
            .then((response: any) => {
                store.commit(Mutations.SET_PREVIEWED_DOCUMENT, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_OAUTH_CLIENT_DATA() {
        axios.get(Endpoints.Admin.OAUTH.OAUTH_CLIENT_DATA)
            .then((response: any) => {
                store.commit(Mutations.SET_OAUTH_CLIENT_DATA, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_ALL_AVAILABLE_APARTMENTS(data: any) {
        axios.get(Endpoints.Admin.WaitingList.AVAILABLE_APARTMENTS(data.id, data.ignore))
            .then((response: any) => {
                store.commit(Mutations.SET_AVAILABLE_APARTMENTS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public ACCEPT_APPLICATION(data: any) {
        axios.put(Endpoints.Admin.WaitingList.ACCEPT_APPLICATION(data.applicationId, data.apartmentId))
            .then(() => {
                store.commit(Mutations.UPDATE_APPLICATION_STATE, data.applicationId);
                store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, false);
                store.dispatch(Actions.RESET_ACTIVE_APPLICATION_ROWS);
                store.commit(Mutations.SET_AVAILABLE_APARTMENTS_VISIBILITY, false);
                NotifyHelpers.notify('application_has_been_accepted', 'positive');
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public ASSIGN_UNIT(data: any) {
        axios.post(Endpoints.Admin.WaitingList.ASSIGN_UNIT(data.applicationId, data.apartmentId))
            .then((response) => {
                store.commit(Mutations.UPDATE_APPLICATION_STATE, data.applicationId);
                store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, false);
                store.dispatch(Actions.RESET_ACTIVE_APPLICATION_ROWS);
                store.commit(Mutations.SET_AVAILABLE_APARTMENTS_VISIBILITY, false);
                NotifyHelpers.notify('application_has_been_accepted', 'positive');

                const property     = response.data.property;
                property.residents = property.active_residents;

                store.commit(Mutations.REFRESH_PROPERTY_CACHED_TENANTS, property);

                store.commit(Mutations.UPDATE_ACTIVE_PROPERTY_DATES, {
                    propertyId:  property.id,
                    vacantFrom:  property.vacant_from,
                    moveInDate:  property.move_in_date,
                    releaseDate: property.release_date,
                });
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public DECLINE_APPLICATION(applicationId: number) {
        axios.put(Endpoints.Admin.WaitingList.DECLINE_APPLICATION(applicationId))
            .then(() => {
                store.commit(Mutations.UPDATE_APPLICATION_STATE, applicationId);
                store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, false);

                store.dispatch(Actions.RESET_ACTIVE_APPLICATION_ROWS);

                NotifyHelpers.notify('application_has_been_rejected', 'positive');
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public TOGGLE_APPLICATION_ACTIVE(data: any) {
        axios.put(Endpoints.Admin.WaitingList.TOGGLE_APPLICATION_ACTIVE(data.applicationId, data.active))
            .then(() => {
                store.commit(Mutations.UPDATE_APPLICATION_STATE, data.applicationId);
                store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, false);
                store.dispatch(Actions.RESET_ACTIVE_APPLICATION_ROWS);

                NotifyHelpers.notify('application_status_toggle', 'positive', data.active);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public SEND_EXPIRATION_EMAIL(data: any) {
        axios.post(Endpoints.Admin.WaitingList.EXPIRATION_EMAIL, data)
            .then(() => {
                store.commit(Mutations.SET_EXPIRATION_EMAIL_VISIBILITY, false);
                NotifyHelpers.notify('expiration_emails_has_been_sent', 'positive');
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                }
            });
    }

    @Action
    public DELETE_APPLICATION(applicationId: number) {
        axios.delete(Endpoints.Admin.WaitingList.CURRENT_APPLICATION(applicationId))
            .then(() => {
                store.commit(Mutations.UPDATE_APPLICATION_STATE, applicationId);
                store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, false);
                store.dispatch(Actions.RESET_ACTIVE_APPLICATION_ROWS);
                NotifyHelpers.notify('application_has_been_deleted', 'positive');
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public UPDATE_APPLICATION(data: any) {
        axios.patch(Endpoints.Admin.WaitingList.CURRENT_APPLICATION(data.id), data)
            .then((response) => {
                store.commit(Mutations.REPLACE_APPLICATION, response.data);
                store.dispatch(Actions.RESET_ACTIVE_APPLICATION_ROWS);
                store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, false);

                NotifyHelpers.notify('application_has_been_updated', 'positive');
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_ALL_WAITING_LISTS(waitingListsData: WaitingListDataResponse[]): void {
        for (const waiting of waitingListsData) {
            this.waitingLists.push(new WaitingListsData(
                waiting.id,
                waiting.first_name,
                waiting.last_name,
                waiting.email,
                waiting.phone,
                waiting.gender,
                waiting.age,
                waiting.education_tags,
                waiting.interests_tags,
                waiting.status,
                waiting.interested_from,
                waiting.created_at,
                waiting.projects,
                waiting.types,
                waiting.about_me,
                waiting.application_motivation,
                waiting.typeform_application_id,
                waiting.address,
                waiting.min_apartment_size,
                waiting.max_apartment_size,
                waiting.min_rent,
                waiting.max_rent,
                waiting.number_of_rooms,
                waiting.option_answers,
            ));
        }
    }

    @Mutation
    public SET_AVAILABLE_APARTMENTS(availableApartmentsData: any): void {
        this.availableApartments = availableApartmentsData;
    }

    @Mutation
    public SET_CURRENT_PREVIEWED_APPLICATION(setPreviewedApplication: ApplicationDataResponse): void {
        this.previewedApplication = setPreviewedApplication;
        this.previewedApplicationState = setPreviewedApplication.state.key;
    }

    @Mutation
    public SET_PREVIEW_APPLICATION_FORM_VISIBILITY(visibility: boolean) {
        this.previewApplicationVisible = visibility;
    }

    @Mutation
    public SET_AVAILABLE_APARTMENTS_VISIBILITY(visibility: boolean) {
        if (!visibility) {
            this.availableApartments = [];
        }
        this.availableApartmentsVisible = visibility;
    }

    @Mutation
    public SET_EXPIRATION_EMAIL_VISIBILITY(visibility: boolean) {
        this.expirationEmailVisible = visibility;
    }

    @Mutation
    public SET_PREVIEWED_DOCUMENT(document: any) {
        this.previewedDocument = 'data:image/png;charset=utf-8;base64,' + document;
    }

    @Mutation
    public SET_PREVIEWED_DOCUMENT_ORIGINAL_NAME(name: any) {
        this.previewedDocumentOriginalName = name;
    }

    @Mutation
    public SET_PREVIEWED_DOCUMENT_EXTENTION(ext: any) {
        this.previewedDocumentExtention = ext;
    }

    @Mutation
    public RESET_PREVIEW_DOCUMENT() {
        this.previewedDocumentLoading = false;
        this.previewedDocument = '';
    }

    @Mutation
    public SET_PREVIEWED_DOCUMENT_LOADING() {
        this.previewedDocumentLoading = true;
    }

    @Mutation
    public UPDATE_APPLICATION_STATE(applicationId: number) {
        this.waitingLists = this.waitingLists.filter((list) => {
            return list.id !== applicationId;
        });
    }

    @Mutation
    public SET_SELECTED_APARTMENT_ID(selectedRowId: number) {
        this.selectedApartmentId = selectedRowId;
    }

    @Mutation
    public SET_OAUTH_CLIENT_DATA(data: any) {
        this.oauthClientData = data;
    }

    @Mutation
    public RESET_WAITING_LISTS() {
        this.waitingLists = [];
    }

    @Mutation
    public REMOVE_EDUCATIONAL_TAG_FROM_APPLICATION(tagId: number) {
        this.previewedApplication.education_tags = this.previewedApplication.education_tags.filter((tag: any) => {
            return tag.id !== tagId;
        });
    }

    @Mutation
    public ADD_EDUCATIONAL_TAG_TO_APPLICATION(tag: any) {
        this.previewedApplication.education_tags = [];
        this.previewedApplication.education_tags.push(tag);
    }

    @Mutation
    public REMOVE_SOCIAL_TAG_FROM_APPLICATION(tagId: number) {
        this.previewedApplication.social_club_tags = this.previewedApplication.social_club_tags.filter((tag: any) => {
            return tag.id !== tagId;
        });
    }

    @Mutation
    public ADD_SOCIAL_TAG_TO_APPLICATION(tag: any) {
        this.previewedApplication.social_club_tags.push(tag);
    }

    @Mutation
    public SET_APPLICATION_MASTER_DATA(data: any) {
        this.applicationMasterData = data;
    }

    @Mutation
    public REPLACE_APPLICATION(waiting: any) {
        this.waitingLists.forEach((application: any, i: number) => {
            if (application.id === waiting.id) {
                const newApplication =  new WaitingListsData(
                    waiting.id,
                    waiting.first_name,
                    waiting.last_name,
                    waiting.email,
                    waiting.phone,
                    waiting.gender,
                    waiting.age,
                    waiting.education_tags,
                    waiting.interests_tags,
                    waiting.status,
                    waiting.interested_from,
                    waiting.created_at,
                    waiting.projects,
                    waiting.types,
                    waiting.about_me,
                    waiting.application_motivation,
                    waiting.typeform_application_id,
                    waiting.address,
                );

                this.waitingLists[i].name           = newApplication.name;
                this.waitingLists[i].email          = newApplication.email;
                this.waitingLists[i].phone          = newApplication.phone;
                this.waitingLists[i].gender         = newApplication.gender;
                this.waitingLists[i].age            = newApplication.age;
                this.waitingLists[i].educationTags  = newApplication.educationTags;
                this.waitingLists[i].interestsTags  = newApplication.interestsTags;
                this.waitingLists[i].interestedFrom = newApplication.interestedFrom;
                this.waitingLists[i].projects       = newApplication.projects;
                this.waitingLists[i].types          = newApplication.types;
                this.waitingLists[i].aboutMe        = newApplication.aboutMe;
                this.waitingLists[i].applicationMotivation = newApplication.applicationMotivation;
            }
        });
    }
}

